import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';

export const usePromptManagementStore = () => {
  return useContext(MobXProviderContext).store;
};
